module.exports = __webpack_public_path__ + "static/media/validacao_data_white.ad054768.svg";